//--------------
// get bleeders
//--------------
export default function getBleeders(combatants) {
  //-------------------------------------------
  // get combatants where bleeding (in/active)
  //-------------------------------------------
  let bleeders = combatants.filter((a) => a.bleeding > 0);
  return bleeders;
}
